// @ts-nocheck
import * as React from "react";

const ThreadRollingDieChanges: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.0"
            width="164.000000pt"
            height="186.000000pt"
            viewBox="0 0 164.000000 186.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g transform="translate(0.000000,186.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M739 1400 c-161 -29 -300 -145 -365 -305 -24 -60 -28 -83 -27 -165 0 -147 50 -261 155 -355 187 -168 466 -163 649 12 254 242 166 663 -164 788 -71 26 -180 38 -248 25z m174 -45 c90 -19 155 -56 221 -125 67 -70 102 -139 118 -230 31 -183 -62 -369 -228 -457 -256 -136 -567 11 -630 297 -31 138 7 275 107 385 62 67 138 112 221 130 82 18 109 18 191 0z" />
                <path d="M837 1150 c-27 -49 -50 -90 -51 -90 -2 0 -16 6 -32 14 -115 57 -183 83 -187 73 -3 -7 -21 -47 -40 -89 l-36 -76 92 -47 c51 -26 96 -50 100 -55 5 -4 -14 -52 -41 -107 l-50 -99 85 -43 c47 -23 87 -41 88 -39 2 2 26 45 54 97 28 52 53 96 55 98 2 2 47 -17 100 -43 54 -25 99 -44 100 -42 1 2 20 40 43 86 l41 82 -92 50 c-50 27 -94 51 -98 52 -4 2 13 45 37 97 25 51 44 95 43 96 -8 7 -149 75 -155 75 -5 0 -30 -40 -56 -90z m165 8 c8 -3 -1 -32 -30 -92 -23 -48 -42 -92 -42 -96 0 -5 43 -32 95 -60 l95 -51 -31 -60 c-34 -69 -28 -69 -151 -9 l-77 38 -52 -96 c-28 -54 -53 -99 -56 -101 -8 -10 -113 50 -113 64 0 9 21 56 46 106 25 50 44 92 42 93 -2 1 -46 24 -98 50 -52 27 -96 50 -98 51 -2 2 10 30 27 63 l31 61 57 -25 c32 -14 79 -36 105 -49 l48 -24 50 94 51 94 44 -24 c25 -13 50 -25 57 -27z" />
            </g>
        </svg>
    );
};

export default React.memo(ThreadRollingDieChanges);
